import { Card } from 'react-bootstrap'

/**
 * User Assessment Status Card component: used to display a status card
 */
export default function AssessmentStatusCard({
  children,
  show = true,
  ...props
}) {
  // Return early if we don't want to show the card
  if (!show) return null

  return (
    <Card className='assessment-card my-3' {...props}>
      <i className='icon bi bi-check2'></i>
      <Card.Body>{children}</Card.Body>
    </Card>
  )
}
